import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'phone'
  })

  export class PhonePipe implements PipeTransform {
    transform(value: any, separateur: string = ' '): any {
        const val: string = value ? value.toString().trim() : '';
        if (val.length === 0) {
            return val;
        }
        // Ajout des 0 à gauche pour obtenir 10 caractères
        const fill: string = '0000000000';
        const phone: string = fill.substr(val.length) + val;
        return phone.slice(0, 2)
            + separateur + phone.slice(2, 4)
            + separateur + phone.slice(4, 6)
            + separateur + phone.slice(6, 8)
            + separateur + phone.slice(8, 10);
    }
  }



// WEBPACK FOOTER //
// /builds/eveasoft/lea/lea-front/src/app/shared/pipes/phone.pipe.ts